/**
 * Функция для получения cardId из блока
 */
export const getCardIdFromBlock = (block: any): string | null => {
  if (!block) return null;

  // Проверяем additionalInfo для карточек
  const getAdditionalInfoVal = (additionalInfo: any[], key: string) => {
    if (!additionalInfo || !Array.isArray(additionalInfo)) return null;
    // Проверяем как по 'key', так и по 'name' (в зависимости от структуры данных)
    const item = additionalInfo.find((info: any) => info.key === key || info.name === key);
    return item?.value || null;
  };

  // Пробуем разные варианты ключей
  const cardsInfoKeys = ['cardsInfo', 'cards', 'cardIds'];
  for (const key of cardsInfoKeys) {
    const cardsInfo = getAdditionalInfoVal(block.additionalInfo || [], key);
    if (cardsInfo) {
      try {
        const cardIds = JSON.parse(cardsInfo);
        if (Array.isArray(cardIds) && cardIds.length > 0) {
          // Поддерживаем оба формата: {cardId: "..."} или просто строку
          return cardIds[0]?.cardId || cardIds[0] || null;
        }
      } catch (e) {
        // Если не JSON, возможно это просто строка с cardId
        if (typeof cardsInfo === 'string' && cardsInfo.length > 0) {
          return cardsInfo;
        }
      }
    }
  }

  // Проверяем cardIds напрямую
  if (block.cardIds && Array.isArray(block.cardIds) && block.cardIds.length > 0) {
    return block.cardIds[0];
  }

  // Проверяем cardId напрямую
  if (block.cardId) {
    return block.cardId;
  }

  return null;
};

/**
 * Фильтрует и расширяет блоки для презентации
 */
export const preparePresentationBlocks = (blocks: any[], presentationStyles: readonly string[]) => {
  const filtered = blocks.filter((block: any) => presentationStyles.includes(block?.style));
  const expanded: any[] = [];

  filtered.forEach((block: any) => {
    if (block.style === 'slider' && block.attachments && block.attachments.length > 0) {
      // Разбиваем slider на отдельные слайды
      block.attachments.forEach((attachment: any, index: number) => {
        expanded.push({
          ...block,
          isSliderSlide: true,
          sliderIndex: index,
          sliderAttachment: attachment,
          // Создаем новый блок для каждого слайда
          attachments: [{ files: attachment.files }],
          overText: attachment.text,
          titlePosition: block.text ? block.titlePosition : (attachment.textPosition || 'bottom'),
        });
      });
    } else {
      expanded.push(block);
    }
  });

  return expanded;
};
/**
 * Функция для получения cardId из блока
 */
export const getCardIdFromBlock = (block: any): string | null => {
  if (!block) return null;

  // Проверяем additionalInfo для карточек
  const getAdditionalInfoVal = (additionalInfo: any[], key: string) => {
    if (!additionalInfo || !Array.isArray(additionalInfo)) return null;
    // Проверяем как по 'key', так и по 'name' (в зависимости от структуры данных)
    const item = additionalInfo.find((info: any) => info.key === key || info.name === key);
    return item?.value || null;
  };

  // Пробуем разные варианты ключей
  const cardsInfoKeys = ['cardsInfo', 'cards', 'cardIds'];
  for (const key of cardsInfoKeys) {
    const cardsInfo = getAdditionalInfoVal(block.additionalInfo || [], key);
    if (cardsInfo) {
      try {
        const cardIds = JSON.parse(cardsInfo);
        if (Array.isArray(cardIds) && cardIds.length > 0) {
          // Поддерживаем оба формата: {cardId: "..."} или просто строку
          return cardIds[0]?.cardId || cardIds[0] || null;
        }
      } catch (e) {
        // Если не JSON, возможно это просто строка с cardId
        if (typeof cardsInfo === 'string' && cardsInfo.length > 0) {
          return cardsInfo;
        }
      }
    }
  }

  // Проверяем cardIds напрямую
  if (block.cardIds && Array.isArray(block.cardIds) && block.cardIds.length > 0) {
    return block.cardIds[0];
  }

  // Проверяем cardId напрямую
  if (block.cardId) {
    return block.cardId;
  }

  return null;
};

/**
 * Фильтрует и расширяет блоки для презентации
 */
export const preparePresentationBlocks = (blocks: any[], presentationStyles: readonly string[]) => {
  const filtered = blocks.filter((block: any) => presentationStyles.includes(block?.style));
  const expanded: any[] = [];

  filtered.forEach((block: any) => {
    if (block.style === 'slider' && block.attachments && block.attachments.length > 0) {
      // Разбиваем slider на отдельные слайды
      block.attachments.forEach((attachment: any, index: number) => {
        expanded.push({
          ...block,
          isSliderSlide: true,
          sliderIndex: index,
          sliderAttachment: attachment,
          // Создаем новый блок для каждого слайда
          attachments: [{ files: attachment.files }],
          overText: attachment.text,
          titlePosition: block.text ? block.titlePosition : (attachment.textPosition || 'bottom'),
        });
      });
    } else {
      expanded.push(block);
    }
  });

  return expanded;
};
